export default __webpack_public_path__ + "static/media/library-02x1920.7a76aa86.jpg";